<template>
  <!-- 店铺首页 -->
  <div class="store_home_page">
    <div class="main" :style="`background-color:${isNoShop?'#ffffff':'#f0f2f5'}`">
      <div class="tabs">
        <dl class="m">
          <dd class="active">
            <router-link :to="'/supermarket/shop_home?shop_id='+$route.query.shop_id" class="link">店铺主页</router-link>
          </dd>
          <dd>
            <router-link
                :to="'/supermarket/shop_home/goods_list?type=RangeServicesResearch&shop_id='+$route.query.shop_id"
                class="link"
            >研究开发服务</router-link>
          </dd>
          <dd>
            <router-link
                :to="'/supermarket/shop_home/goods_list?type=RangeServicesCheck&shop_id='+$route.query.shop_id"
                class="link"
            >检验检测服务</router-link>
          </dd>
          <dd>
            <router-link
                :to="'/supermarket/shop_home/goods_list?type=RangeServicesShare&shop_id='+$route.query.shop_id"
                class="link"
            >大型科学仪器共享服务</router-link>
          </dd>
          <dd>
            <router-link
                :to="'/supermarket/shop_home/goods_list?type=RangeServicesOther&class_two=RangeServicesOtherIPR&shop_id='+$route.query.shop_id"
                class="link"
            >知识产权</router-link>
          </dd>
          <dd>
            <router-link
                :to="'/supermarket/shop_home/goods_list?type=RangeServicesOther&class_two=RangeServicesOtherOther&shop_id='+$route.query.shop_id"
                class="link"
            >其他</router-link>
          </dd>
          <dd>
            <router-link :to="'/supermarket/shop_home/introduction?shop_id='+$route.query.shop_id" class="link">店铺简介</router-link>
          </dd>
        </dl>
      </div>
      <banner></banner>
      <div class="m" >
        <div  class="no-shop" v-if="isNoShop">
          <img :src="noShop" alt="">
          <p>暂无商品信息</p>
        </div>
        <!-- 研究开发 -->
        <storeItemList
            title="研究开发服务"
            :layerpageinfo="layerpageinfo1"
            :list="list1"
            @changePage="handleData1"
        ></storeItemList>
        <!-- 检验检测 -->
        <storeItemList
            title="检验检测服务"
            :layerpageinfo="layerpageinfo2"
            :list="list2"
            @changePage="handleData2"
        ></storeItemList>
        <!-- 仪器共享 -->
        <storeItemList
            title="大型科学仪器设施共享服务"
            :layerpageinfo="layerpageinfo3"
            :list="list3"
            @changePage="handleData3"
        ></storeItemList>

        <div style="padding-bottom: 50px" v-if="!isNoShop"></div>
      </div>
    </div>
  </div>
</template>

<script>
import noShop from '@/assets/img/supermarker/no-shop.png'
import banner from "@/views/supermarket/components/banner.vue";
import storeItemList from "@/views/supermarket/components/store_item_list.vue";
export default {
  components: {
    banner,
    storeItemList,
  },
  data() {
    return {
      noShop: noShop, //没有商品显示的图片
      isNoShop: true, //是否没有商品
      list1: [],
      layerpageinfo1:{
        pageNo: 0,
        pageSize: 8,
        total: 0,
        class_one: 'RangeServicesResearch'
      },
      list2: [],
      layerpageinfo2:{
        pageNo: 0,
        pageSize: 8,
        total: 0,
        class_one: 'RangeServicesCheck'
      },
      list3: [],
      layerpageinfo3:{
        pageNo: 0,
        pageSize: 8,
        total: 0,
        class_one: 'RangeServicesShare'
      },
    };
  },
  created() {
    this.initService();
  },
  methods: {
    async initService(){
      await this.getService(this.layerpageinfo1, (res)=>{
        this.list1 = res.obj.list;
        this.layerpageinfo1.total = res.obj.totalSize;
      })
      await this.getService(this.layerpageinfo2, (res)=>{
        this.list2 = res.obj.list;
        this.layerpageinfo2.total = res.obj.totalSize;
      })
      await this.getService(this.layerpageinfo3, (res)=>{
        this.list3 = res.obj.list;
        this.layerpageinfo3.total = res.obj.totalSize;
      })
      if(this.list1.length > 0 || this.list2.length > 0 || this.list3.length > 0){
        this.isNoShop = false;
      }
    },
    //获取服务
    getService(obj, fn){
      let params = {
        statusCode: 'EntityStatusOnShelves',
        institute: this.$route.query.shop_id,
        active: true,
        ...obj
      };
      return this.api.getServicesHZ(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        fn && fn(res);
      });
    },
    //研究开发服务切换分页
    handleData1(obj){
      this.getService(obj, (res)=>{
        this.list1 = res.obj.list;
        this.layerpageinfo1.total = res.obj.totalSize;
      })
    },
    //检验检测服务切换分页
    handleData2(obj){
      this.getService(obj, (res)=>{
        this.list2 = res.obj.list;
        this.layerpageinfo2.total = res.obj.totalSize;
      })
    },
    //仪器共享切换分页
    handleData3(obj){
      this.getService(obj, (res)=>{
        this.list3 = res.obj.list;
        this.layerpageinfo3.total = res.obj.totalSize;
      })
    },
  }
};
</script>

<style lang="scss">
.store_home_page {
  .main {
    background-color: #f0f2f5;
    .tabs{
      height: 54px;
      background-color: #27313f;

      dl {
        display: flex;
        color: #ffffff;

        dd {
          line-height: 54px;
          position: relative;
          margin-right: 66px;
          cursor: pointer;
          .link {
            display: inline-block;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #ffffff;
          }
        }

        dd.active,dd.active .link,
        dd:hover {
          color: #ff733c;
        }

        dd.active:before,
        dd:hover:before {
          content: "";
          position: absolute;
          width: 32px;
          height: 3px;
          background-color: #ff733c;
          bottom: 0px;
          left: 0px;
          right: 0px;
          margin: 0 auto;
        }
      }
    }
    .no-shop{
      padding: 70px 0;
      text-align: center;

      p{
        font-size: 14px;
        color: #a4a8ba;
        margin-top: -40px;
      }
    }
  }
}
</style>
